module.exports = __webpack_public_path__ + "static/opshop17.d51b2fd5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/opshop17.jpg
// module id = 504
// module chunks = 114276838955818